var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 10.4492V15.918C11.8164 16.2964 12.1216 16.6016 12.5 16.6016C12.8784 16.6016 13.1836 16.2964 13.1836 15.918V10.4492C13.1836 10.0708 12.8784 9.76562 12.5 9.76562C12.1216 9.76562 11.8164 10.0708 11.8164 10.4492Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 18.6523C11.8164 18.8336 11.8884 19.0075 12.0166 19.1357C12.1448 19.2639 12.3187 19.3359 12.5 19.3359C12.6813 19.3359 12.8552 19.2639 12.9834 19.1357C13.1116 19.0075 13.1836 18.8336 13.1836 18.6523C13.1836 18.471 13.1116 18.2972 12.9834 18.169C12.8552 18.0408 12.6813 17.9688 12.5 17.9688C12.3187 17.9688 12.1448 18.0408 12.0166 18.169C11.8884 18.2972 11.8164 18.471 11.8164 18.6523Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2569 20.144L13.6573 3.51807C13.401 3.07373 12.9493 2.84912 12.5001 2.84912C12.0509 2.84912 11.5992 3.07129 11.3429 3.51807L1.74326 20.144C1.22812 21.0352 1.87265 22.1484 2.90049 22.1484H22.0997C23.1275 22.1484 23.7721 21.0352 23.2569 20.144ZM2.92734 20.8276L12.5001 4.24805L22.0997 20.7812L2.92734 20.8276Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.05ae7d73f9a99e1356b56aa9be5f2242.svg";
export { ForwardRef as ReactComponent };